import { HomePageLayoutBlueprint } from '@backstage/plugin-home-react/alpha';

export const homeLayout = HomePageLayoutBlueprint.make({
  name: 'fixed-grid',
  params: {
    loader: async () => {
      const { default: Grid } = await import('@material-ui/core/Grid');
      const { Content } = await import('@backstage/core-components');

      return function FixedHomePageLayout({ widgets }) {
        const findWidget = (suffix: string) =>
          widgets.find(w => w.name?.endsWith(suffix))?.component;

        return (
          <Content>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                {findWidget('featured-docs')}
              </Grid>
              <Grid item xs={12} md={6}>
                {findWidget('vorwerk-toolkit')}
              </Grid>
              <Grid item xs={12} md={6}>
                {findWidget('starred-entities')}
              </Grid>
            </Grid>
          </Content>
        );
      };
    },
  },
});
